import posthog from 'posthog-js';

// Feature flags (PostHog). Keep flag keys here so gates read from one place.
export const PROJECTS_V2_FLAG = 'projects-v2';

// The projects "v2" experience: deliverables + tasks + documents, the redesigned
// project overview, the new project-form fields, and the richer projects rows.
// Everything in that set is gated behind this flag.
export const isProjectsV2Enabled = (): boolean => !!posthog.isFeatureEnabled(PROJECTS_V2_FLAG);

export const REFRIGERANT_TRACKING_FLAG = 'refrigerant_tracking_enabled';

// EPA 608 refrigerant tracking: the Refrigerant Tracking tabs (asset overview, asset detail, work
// order detail) and everything behind them, the refrigerant fields on the asset and asset-type
// forms, the technician's EPA certification on the contact/field-tech/role forms, and the work
// order "Has Refrigerant Events" filter. Every one of those gates reads this flag.
//
// Gating the WRITE paths matters as much as the UI: with the fields unrendered, the payload
// builders would send `isRefrigerantTracked: false` / an explicit cleared certification and a
// flag-off user saving an unrelated attribute would silently wipe a flag-on user's data. Wherever a
// form is gated, the corresponding submit-side branch is gated on the same call.
export const isRefrigerantTrackingEnabled = (): boolean =>
	!!posthog.isFeatureEnabled(REFRIGERANT_TRACKING_FLAG);

export const INVOICE_WORK_ORDER_CHECK_FLAG = 'invoice-work-order-check';

// The invoice → work order check and everything derived from it: the mismatch confirmation on a
// parsed upload, the comparison table kept on the invoice form, and the "Enrich Data?" asset
// suggestion banner on invoice detail. All three come from one backend payload (`work_order_check`,
// which carries `asset_suggestion` inside it), so one flag covers the set.
//
// This sits on top of the backend's own switches (`openwrench.decisions.invoice.enabled` and
// `.surface_in_response`), which are global config. This flag is what makes a staged, per-company
// rollout possible while those stay on.
//
// Gating the REQUEST matters most: with the flag off the AI forms stop sending `workOrderId` to the
// extraction endpoint, so the backend never runs the decision and no verdict exists to render. The
// banner is gated separately because `assetSuggestion` is persisted on the invoice — without that,
// invoices created while the flag was on would keep offering asset writes after it was turned off.
export const isInvoiceWorkOrderCheckEnabled = (): boolean =>
	!!posthog.isFeatureEnabled(INVOICE_WORK_ORDER_CHECK_FLAG);
